__turbopack_context__.v({
  "button": "readyStepSection-module-scss-module__UGsaJG__button",
  "containerDesktop": "readyStepSection-module-scss-module__UGsaJG__containerDesktop",
  "containerMobile": "readyStepSection-module-scss-module__UGsaJG__containerMobile",
  "ctaContainer": "readyStepSection-module-scss-module__UGsaJG__ctaContainer",
  "description": "readyStepSection-module-scss-module__UGsaJG__description",
  "gdpr": "readyStepSection-module-scss-module__UGsaJG__gdpr",
  "heading": "readyStepSection-module-scss-module__UGsaJG__heading",
});
